document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-bundle-detail]").forEach((root) => {
    const jsonScript = root.querySelector("[data-bundle-detail-json]");
    if (!jsonScript) return;

    let data = null;
    try {
      data = JSON.parse(jsonScript.textContent || "{}");
    } catch (error) {
      console.error("Bundle detail JSON parse failed", error);
      return;
    }

    const recipe = data.recipe || {};
    const designGroups = data.designGroupsLite || [];
    let activeDesignProducts = data.initialDesignProducts || [];

    const designProductIndex = data.designProductIndex || {};

    const slotsMount = root.querySelector("[data-bundle-detail-slots]");
    const comparePriceEl = root.querySelector("[data-bundle-detail-compare-price]");
    const finalPriceEl = root.querySelector("[data-bundle-detail-final-price]");
    const addButton = root.querySelector("[data-bundle-detail-add]");

    const modal = root.querySelector("[data-bundle-design-modal]");
    const openModalBtn = root.querySelector("[data-bundle-open-design-modal]");
    const closeModalBtns = root.querySelectorAll("[data-bundle-close-design-modal]");
    const designGrid = root.querySelector("[data-bundle-design-grid]");
    const designRail = root.querySelector("[data-bundle-design-rail]");
    const designPagination = root.querySelector("[data-bundle-design-pagination]");
    const designSearchInput = root.querySelector("[data-bundle-design-search]");
    const designLoading = root.querySelector("[data-bundle-design-loading]");

    const addButtonSpinner = addButton?.querySelector(".bundle-detail__add-button-spinner");

    const phoneCaseTypeOrder = [
      "Snap Case",
      "Tough Case",
      "MagSafe Tough Case",
      "Biodegradable Case",
      "Flip Case"
    ];

    const gripCompatiblePhoneCaseTypeOrder = [
  "Snap Case",
  "Tough Case",
  "MagSafe Tough Case",
  "Biodegradable Case"
];

    const earbudsCaseTypeOrder = [
      "Apple Airpods Case",
      "Apple AirPods Case",
      "Samsung Buds Case",
      "Google Pixel Buds Case",
      "Apple Airpods Max Case",
      "Apple AirPods Max Case",
      "AirPods Case",
      "AirPods Max Case"
    ];

    const appleEarbudsCaseTypeOrder = [
  "Apple Airpods Case",
  "Apple AirPods Case",
  "AirPods Case",
  "Apple Airpods Max Case",
  "Apple AirPods Max Case",
  "AirPods Max Case"
];

const appleWatchBandTypeOrder = [
  "Apple Watch Band"
];

    const drinkwareTypeOrder = ["Large Tumbler", "Insulated Travel Mug"];

      const ipadCaseTypeOrder = [
  "iPad Case",
  "Ipad Case",
  "Tablet Case"
];


    const laptopProtectionTypeOrder = ["Premium Laptop Sleeve", "MacBook Case"];

    let selectedStateBySlot = {};

    
    let activeDesignPage = 1;
    const modalDesignsPerPage = 30;
    const railDesignLimit = 24;
    let designSearchQuery = "";
    let designSearchTimeout = null;
    let activeImageIndex = 0;
    let prioritizeSelectedDesignInRail = false;
    let slotsLoading = false;

    const urlDesignHandle = new URLSearchParams(window.location.search).get("design");
    let activeDesignHandle =
      urlDesignHandle && designGroups.some((group) => group.handle === urlDesignHandle)
        ? urlDesignHandle
        : (data.initialDesignHandle || designGroups[0]?.handle || "");

    const designProductsCache = {
      [data.initialDesignHandle]: data.initialDesignProducts || []
    };

    function setAddButtonLoading(isLoading) {
      if (!addButton) return;
      addButton.classList.toggle("is-loading", isLoading);
      if (addButtonSpinner) {
        addButtonSpinner.classList.toggle("hidden", !isLoading);
      }
    }



    function updatePrice() {
  const slots = Object.values(selectedStateBySlot);

  const original = slots.reduce((sum, item) => {
    return sum + getBundleBasePrice(item?.variant);
  }, 0);

  const discounted = calculateDiscountedTotal(original, recipe.discount);

  if (finalPriceEl) {
    finalPriceEl.textContent = discounted > 0 ? formatMoney(discounted) : "";
  }

  if (comparePriceEl) {
    comparePriceEl.innerHTML =
      discounted > 0 && discounted < original
        ? `<s>${formatMoney(original)}</s>`
        : "";
  }
}




    function setDesignLoading(isLoading) {
      if (!designLoading) return;
      designLoading.hidden = !isLoading;
    }

    function setSlotsLoading(isLoading) {
      slotsLoading = isLoading;
      renderSlots();
    }

    function normalizeProductType(type) {
      const value = String(type || "").trim();
      const map = {
  "Apple AirPods Case": "Apple Airpods Case",
  "AirPods Case": "Apple Airpods Case",
  "Apple AirPods Max Case": "Apple Airpods Max Case",
  "AirPods Max Case": "Apple Airpods Max Case",

  "Wireless Charger": "Wireless Chargers",
  "Wireless Chargers": "Wireless Chargers",

  "Ring Holder": "Magnetic Ring Holder",
  "Magnetic Ring Holder": "Magnetic Ring Holder",

  "iPad Case": "Ipad Case",
"IPad Case": "Ipad Case",
"Tablet Case": "Ipad Case",

  "Phone Grip": "Phone Click-On Grip",
  "Phone Click-On Grip": "Phone Click-On Grip",
  "Click-On Grip": "Phone Click-On Grip",
  "Phone Stand Holder": "Phone Click-On Grip",

  "Premium Laptop Sleeve": "Premium Laptop Sleeve",
"Laptop Sleeve": "Premium Laptop Sleeve",

"MacBook Case": "MacBook Case",
"Macbook Case": "MacBook Case",
"MacBook Cover": "MacBook Case",
"Laptop Case": "MacBook Case",

"Apple Watch Band": "Apple Watch Band",
"Apple Watchband": "Apple Watch Band",
"Watch Band": "Apple Watch Band",
"Apple Watch Strap": "Apple Watch Band",
"Watch Strap": "Apple Watch Band"


};
      return map[value] || value;
    }

    function slugify(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/&/g, "and")
        .replace(/['"]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }

    function getImageUrl(image) {
  if (!image) return "";

  if (typeof image === "string") return image;

  return (
    image.src ||
    image.url ||
    image.preview_image?.src ||
    image.preview_image?.url ||
    ""
  );
}

    function formatMoney(cents) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }

    function calculateDiscountedTotal(total, discountPercent) {
      return Math.round(total * (1 - Number(discountPercent || 0) / 100));
    }

    function getBundleBasePrice(variant) {
  if (!variant) return 0;

  const price = Number(variant.price || 0);
  const compareAt = Number(
    variant.compare_at_price ||
    variant.compareAtPrice ||
    variant.compare_at_price_amount ||
    0
  );

  return compareAt > price ? compareAt : price;
}

    function calculateOriginalPriceFromDiscount(discountedPrice, discountPercent) {
      const price = Number(discountedPrice || 0);
      const discount = Number(discountPercent || 0);
      if (price <= 0 || discount <= 0 || discount >= 100) return 0;
      return Math.round(price / (1 - discount / 100));
    }

    function getSortedDesignGroups({ prioritizeSelected = false } = {}) {
      if (!prioritizeSelected) return [...designGroups];
      const activeGroup = designGroups.find((group) => group.handle === activeDesignHandle);
      const remainingGroups = designGroups.filter((group) => group.handle !== activeDesignHandle);
      return activeGroup ? [activeGroup, ...remainingGroups] : [...designGroups];
    }

    function getFilteredDesignGroups({ prioritizeSelected = false } = {}) {
      let groups = getSortedDesignGroups({ prioritizeSelected });
      if (!designSearchQuery.trim()) return groups;

      const query = designSearchQuery.trim().toLowerCase();
      return groups.filter((group) => String(group.name || "").toLowerCase().includes(query));
    }

    function getPaginatedDesignGroups() {
      const filtered = getFilteredDesignGroups({ prioritizeSelected: true });
      const start = (activeDesignPage - 1) * modalDesignsPerPage;
      const end = start + modalDesignsPerPage;
      return filtered.slice(start, end);
    }

    function getModalPageCount() {
      return Math.max(1, Math.ceil(getFilteredDesignGroups({ prioritizeSelected: true }).length / modalDesignsPerPage));
    }

    function getActiveDesignMeta() {
      return designGroups.find((group) => group.handle === activeDesignHandle) || null;
    }

    function getActiveDesignProducts() {
      return activeDesignProducts || [];
    }

    function getRequiredProductTypesForRule(rule) {
      switch (rule) {
        case "same_design_phone_case":
        case "fallback_same_design_phone_case":
        case "current_product_if_phone_case":
          return [
            "Snap Case",
            "Tough Case",
            "MagSafe Tough Case",
            "Biodegradable Case",
            "Flip Case"
          ];

        case "same_design_earbuds_case":
          return [
            "Apple Airpods Case",
            "Samsung Buds Case",
            "Google Pixel Buds Case",
            "Apple Airpods Max Case"
          ];

        case "same_design_apple_earbuds_case":
          return [
            "Apple Airpods Case",
            "Apple Airpods Max Case"
          ];

        case "same_design_apple_watch_band":
          return ["Apple Watch Band"];

        case "same_design_drinkware":
          return ["Large Tumbler", "Insulated Travel Mug"];

        case "same_design_premium_laptop_sleeve":
  return ["Premium Laptop Sleeve"];

case "same_design_macbook_case":
  return ["MacBook Case"];

case "same_design_laptop_protection":
  return ["Premium Laptop Sleeve", "MacBook Case"];

        case "same_design_ipad_case":
          return ["iPad Case", "Ipad Case", "Tablet Case"];

        case "same_design_magsafe_tough_case":
          return ["MagSafe Tough Case"];

        case "same_design_ring_holder":
          return ["Magnetic Ring Holder"];

        case "same_design_wireless_charger":
          return ["Wireless Chargers"];

        case "same_design_mobile_display_stand":
          return ["Mobile Display Stand"];

        case "same_design_grip_compatible_phone_case":
          return [
            "Snap Case",
            "Tough Case",
            "MagSafe Tough Case",
            "Biodegradable Case"
          ];

        case "same_design_crossbody_phone_purse":
          return ["Crossbody Phone Purse"];

        case "same_design_phone_grip":
          return ["Phone Click-On Grip"];

        default:
          return [];
      }
    }

    

    function getRequiredProductTypesForRecipe() {
  const typeSet = new Set();

  getVisibleSlots().forEach((slot) => {
    (slot.rules || []).forEach((rule) => {
      getRequiredProductTypesForRule(rule).forEach((type) => typeSet.add(type));
    });
  });

  return Array.from(typeSet);
}

    async function fetchProductByHandle(handle) {
      const response = await fetch(`/products/${handle}.js`, {
        headers: { Accept: "application/json" }
      });

      if (!response.ok) {
        return null;
      }

      const product = await response.json();

      return {
        id: product.id,
        title: product.title,
        type: product.type,
        handle: product.handle,
        url: product.url,
        featuredImage: product.featured_image || "",
        price: product.price,
        compareAtPrice: product.compare_at_price,
        variantId: product.variants?.[0]?.id || null,
        selectedOrFirstAvailableVariantId:
          product.variants?.find((v) => v.available)?.id || product.variants?.[0]?.id || null,
        options: (product.options || []).map((option, index) => {
  const optionName =
    typeof option === "string"
      ? option
      : option?.name || `Option ${index + 1}`;

  return {
    name: optionName,
    position: index + 1,
    values: [
      ...new Set(
        (product.variants || [])
          .map((variant) => variant[`option${index + 1}`])
          .filter(Boolean)
      )
    ]
  };
}),
        variants: (product.variants || []).map((variant) => ({
          id: variant.id,
          title: variant.title,
          available: variant.available,
          price: variant.price,
          compare_at_price: variant.compare_at_price,
          option1: variant.option1 || null,
          option2: variant.option2 || null,
          option3: variant.option3 || null,
          featuredImage: getImageUrl(variant.featured_image)
        }))
      };
    }

    async function fetchProductByType(designHandle, type) {
  const productsForDesign = designProductIndex[designHandle] || [];
  const normalizedTargetType = normalizeProductType(type);

  const indexedProduct = productsForDesign.find((product) => {
    return normalizeProductType(product.type) === normalizedTargetType;
  });

  if (!indexedProduct?.handle) {
    console.warn("No indexed product found for design/type", {
      designHandle,
      type,
      availableProducts: productsForDesign
    });
    return null;
  }

  const product = await fetchProductByHandle(indexedProduct.handle);

  if (!product) {
    console.warn("Indexed product handle failed to fetch", {
      designHandle,
      type,
      handle: indexedProduct.handle
    });
    return null;
  }

  return product;
}

    async function fetchDesignProducts(designHandle) {
  if (designProductsCache[designHandle]) {
    return designProductsCache[designHandle];
  }

  const requiredTypes = getRequiredProductTypesForRecipe();

  const results = await Promise.allSettled(
    requiredTypes.map((type) => fetchProductByType(designHandle, type))
  );

  const products = results
    .filter((result) => result.status === "fulfilled" && result.value)
    .map((result) => result.value);

  const dedupedProducts = [];
  const seenHandles = new Set();

  products.forEach((product) => {
    if (!product?.handle || seenHandles.has(product.handle)) return;
    seenHandles.add(product.handle);
    dedupedProducts.push(product);
  });

  designProductsCache[designHandle] = dedupedProducts;
  return dedupedProducts;
}


    function getVisibleSlots() {
  return (recipe.slots || []).filter((slot) => {
    return String(slot?.label || "").trim() !== "";
  });
}

    function findAllByTypes(types) {
      const normalizedTypes = types.map(normalizeProductType);
      return getActiveDesignProducts().filter((product) =>
        normalizedTypes.includes(normalizeProductType(product.type))
      );
    }

    function findAllByType(type) {
      return getActiveDesignProducts().filter(
        (product) => normalizeProductType(product.type) === normalizeProductType(type)
      );
    }

    function sortProductsByTypeOrder(products, orderedTypes) {
      const normalizedOrder = orderedTypes.map(normalizeProductType);

      return [...products].sort((a, b) => {
        const aType = normalizeProductType(a.type);
        const bType = normalizeProductType(b.type);

        const aIndex = normalizedOrder.indexOf(aType);
        const bIndex = normalizedOrder.indexOf(bType);

        const safeAIndex = aIndex === -1 ? 999 : aIndex;
        const safeBIndex = bIndex === -1 ? 999 : bIndex;

        if (safeAIndex !== safeBIndex) return safeAIndex - safeBIndex;
        return String(a.title || "").localeCompare(String(b.title || ""));
      });
    }

    function getSlotOptions(slot) {
      const rules = slot.rules || [];
      const fixedProducts = slot.fixedProducts || [];

      for (const rule of rules) {
        if (rule === "fixed_product" && fixedProducts.length) return [fixedProducts[0]];
        if (rule === "fixed_list_of_products" && fixedProducts.length) return fixedProducts;

        if (
          rule === "same_design_phone_case" ||
          rule === "fallback_same_design_phone_case" ||
          rule === "current_product_if_phone_case"
        ) {
          const matches = findAllByTypes(phoneCaseTypeOrder);
          if (matches.length) return sortProductsByTypeOrder(matches, phoneCaseTypeOrder);
        }

        if (rule === "same_design_grip_compatible_phone_case") {
  const matches = findAllByTypes(gripCompatiblePhoneCaseTypeOrder);
  if (matches.length) {
    return sortProductsByTypeOrder(matches, gripCompatiblePhoneCaseTypeOrder);
  }
}

if (rule === "same_design_phone_grip") {
  const matches = findAllByTypes(["Phone Click-On Grip", "Phone Grip", "Click-On Grip"]);
  if (matches.length) return matches;
}

        if (rule === "same_design_earbuds_case") {
          const matches = findAllByTypes(earbudsCaseTypeOrder);
          if (matches.length) return sortProductsByTypeOrder(matches, earbudsCaseTypeOrder);
        }


        if (rule === "same_design_apple_earbuds_case") {
  const matches = findAllByTypes(appleEarbudsCaseTypeOrder);
  if (matches.length) {
    return sortProductsByTypeOrder(matches, appleEarbudsCaseTypeOrder);
  }
}

if (rule === "same_design_apple_watch_band") {
  const matches = findAllByTypes(appleWatchBandTypeOrder);
  if (matches.length) {
    return sortProductsByTypeOrder(matches, appleWatchBandTypeOrder);
  }
}


        if (rule === "same_design_drinkware") {
          const matches = findAllByTypes(drinkwareTypeOrder);
          if (matches.length) return sortProductsByTypeOrder(matches, drinkwareTypeOrder);
        }



        if (rule === "same_design_ipad_case") {
  const matches = findAllByTypes(ipadCaseTypeOrder);

  if (matches.length) {
    return sortProductsByTypeOrder(matches, ipadCaseTypeOrder);
  }
}



        if (rule === "same_design_premium_laptop_sleeve") {
  const matches = findAllByType("Premium Laptop Sleeve");
  if (matches.length) return matches;
}

if (rule === "same_design_macbook_case") {
  const matches = findAllByType("MacBook Case");
  if (matches.length) return matches;
}

if (rule === "same_design_laptop_protection") {
  const matches = findAllByTypes(laptopProtectionTypeOrder);
  if (matches.length) {
    return sortProductsByTypeOrder(matches, laptopProtectionTypeOrder);
  }
}

        if (rule === "same_design_magsafe_tough_case") {
          const matches = findAllByType("MagSafe Tough Case");
          if (matches.length) return matches;
        }

        if (rule === "same_design_ring_holder") {
          const matches = findAllByTypes(["Ring Holder", "Magnetic Ring Holder"]);
          if (matches.length) return matches;
        }

        if (rule === "same_design_wireless_charger") {
          const matches = findAllByTypes(["Wireless Charger", "Wireless Chargers"]);
          if (matches.length) return matches;
        }

        if (rule === "same_design_mobile_display_stand") {
  const matches = findAllByType("Mobile Display Stand");
  if (matches.length) return matches;
}


        if (rule === "same_design_crossbody_phone_purse") {
  const matches = findAllByType("Crossbody Phone Purse");
  if (matches.length) return matches;
}


      }

      return fixedProducts.length ? fixedProducts : [];
    }

    function getDefaultSelectedProduct(slot, options) {
      if (!options.length) return null;

      const rules = slot.rules || [];
      const isPhoneCaseSlot =
  rules.includes("current_product_if_phone_case") ||
  rules.includes("same_design_phone_case") ||
  rules.includes("fallback_same_design_phone_case") ||
  rules.includes("same_design_grip_compatible_phone_case");

const isPhoneGripSlot = rules.includes("same_design_phone_grip");


const isEarbudsSlot =
  rules.includes("same_design_earbuds_case") ||
  rules.includes("same_design_apple_earbuds_case");

const isAppleWatchBandSlot = rules.includes("same_design_apple_watch_band");

      const isDrinkwareSlot = rules.includes("same_design_drinkware");
const isMobileDisplayStandSlot = rules.includes("same_design_mobile_display_stand");
const isFixedSlot = rules.includes("fixed_product") || rules.includes("fixed_list_of_products");

const isIpadCaseSlot = rules.includes("same_design_ipad_case");

const isLaptopProtectionSlot = rules.includes("same_design_laptop_protection");

const isCrossbodyPhonePurseSlot = rules.includes("same_design_crossbody_phone_purse");

      if (isPhoneCaseSlot) {
        return (
          options.find((product) => normalizeProductType(product.type) === normalizeProductType("Tough Case")) ||
          options[0]
        );
      }

      if (isPhoneGripSlot) {
  return options[0];
}

      if (isEarbudsSlot) {
        return (
          options.find((product) => normalizeProductType(product.type) === normalizeProductType("Apple Airpods Case")) ||
          options[0]
        );
      }

      if (isAppleWatchBandSlot) {
  return options[0];
}

      if (isDrinkwareSlot) {
        return (
          options.find((product) => normalizeProductType(product.type) === normalizeProductType("Large Tumbler")) ||
          options[0]
        );
      }

      if (isIpadCaseSlot) {
  return (
    options.find((product) => normalizeProductType(product.type) === normalizeProductType("Ipad Case")) ||
    options[0]
  );
}


      if (isMobileDisplayStandSlot) {
  return options[0];
}


      if (isLaptopProtectionSlot) {
  return (
    options.find((product) => normalizeProductType(product.type) === normalizeProductType("Premium Laptop Sleeve")) ||
    options.find((product) => normalizeProductType(product.type) === normalizeProductType("MacBook Case")) ||
    options[0]
  );
}


      if (isFixedSlot) {
        return (
          options.find(
            (product) =>
              normalizeProductType(product.type) === normalizeProductType("Premium Screen Protector") ||
              String(product.title || "").toLowerCase().includes("screen protector")
          ) || options[0]
        );
      }

      return options[0];
    }

    function getDefaultVariant(product) {
      if (!product?.variants?.length) return null;

      return (
        product.variants.find(
          (variant) => String(variant.id) === String(product.selectedOrFirstAvailableVariantId)
        ) ||
        product.variants.find((variant) => variant.available) ||
        product.variants[0]
      );
    }

    function findMatchingVariant(product, selectedOptions) {
      if (!product?.variants?.length) return null;

      return (
        product.variants.find((variant) =>
          selectedOptions.every((value, index) => !value || variant[`option${index + 1}`] === value)
        ) ||
        product.variants.find((variant) => variant.available) ||
        product.variants[0]
      );
    }

    function updateMountedItemPrice(slotMount, variant) {
  const priceWrapper = slotMount.querySelector("[data-bundle-price-wrapper]");
  if (!priceWrapper || !variant) return;

  const originalPrice = getBundleBasePrice(variant);
  const discountedPrice = calculateDiscountedTotal(originalPrice, recipe.discount || 0);

  priceWrapper.innerHTML = `
    ${
      originalPrice > discountedPrice
        ? `<span class="bundle-native-item__price-compare">${formatMoney(originalPrice)}</span>`
        : ""
    }
    <span class="bundle-native-item__price-sale">${formatMoney(discountedPrice)}</span>
  `;
}


    function updateMountedItemImage(slotMount, product, variant) {
  const image = slotMount.querySelector(".bundle-native-item__image");
  if (!image) return;

  const nextImage =
    variant?.featuredImage ||
    getImageUrl(variant?.featured_image) ||
    getImageUrl(variant?.featured_media?.preview_image) ||
    product?.featuredImage ||
    "";

  if (nextImage) {
    image.src = nextImage;
  }
}



    function bindMountedVariantEvents(slotMount, product, slotIndex) {
      const selects = slotMount.querySelectorAll("[data-bundle-option-index]");
      if (!selects.length) return;

      const updateVariantFromSelects = () => {
        const selectedOptions = Array.from(selects).map((select) => select.value);
        const variant = findMatchingVariant(product, selectedOptions);

        if (selectedStateBySlot[slotIndex]) {
          selectedStateBySlot[slotIndex] = {
            ...selectedStateBySlot[slotIndex],
            variant
          };
        }

        const hiddenVariantInput = slotMount.querySelector("[data-bundle-variant-id]");
        if (hiddenVariantInput && variant) {
          hiddenVariantInput.value = variant.id;
        }

        updateMountedItemPrice(slotMount, variant);
updateMountedItemImage(slotMount, product, variant);
updatePrice();
      };

      selects.forEach((select) => {
        select.addEventListener("change", updateVariantFromSelects);
      });

      updateVariantFromSelects();
    }

    function mountProductTemplate(slotMount, product, slotIndex) {
      if (!slotMount || !product) return;

      const variant = selectedStateBySlot[slotIndex]?.variant || getDefaultVariant(product);
      const optionGroups = product.options || [];

      const initialImage =
  variant?.featuredImage ||
  getImageUrl(variant?.featured_image) ||
  getImageUrl(variant?.featured_media?.preview_image) ||
  product.featuredImage ||
  "";

      slotMount.innerHTML = `
        <div class="bundle-native-item" data-bundle-native-item>
          <div class="bundle-native-item__image-wrap">
            ${initialImage ? `<img src="${initialImage}" alt="${product.title}" class="bundle-native-item__image">` : ""}
          </div>

          <div class="bundle-native-item__content">
            <div class="bundle-native-item__title">${product.title}</div>

            <div class="bundle-native-item__price" data-bundle-price-wrapper>
  ${(() => {
    const originalPrice = getBundleBasePrice(variant);
    const discountedPrice = calculateDiscountedTotal(originalPrice, recipe.discount || 0);

    return `
      ${
        originalPrice > discountedPrice
          ? `<span class="bundle-native-item__price-compare">${formatMoney(originalPrice)}</span>`
          : ""
      }
      <span class="bundle-native-item__price-sale">${formatMoney(discountedPrice)}</span>
    `;
  })()}
</div>

            <div class="bundle-native-item__variants">
              ${optionGroups
                .map((option, optionIndex) => {
                  if (!option?.values?.length) return "";
                  return `
                    <div class="product-form__input product-form__input--dropdown">
                      <label class="form__label" for="BundleOption-${slotIndex}-${optionIndex}">
                        ${typeof option.name === "string" ? option.name : ""}
                      </label>
                      <div class="select">
                        <select
                          id="BundleOption-${slotIndex}-${optionIndex}"
                          class="select__select"
                          data-bundle-option-index="${optionIndex}"
                        >
                          ${option.values
                            .map((value) => {
                              const selected =
                                [variant?.option1, variant?.option2, variant?.option3][optionIndex] === value;
                              return `<option value="${value}" ${selected ? "selected" : ""}>${value}</option>`;
                            })
                            .join("")}
                        </select>
                      </div>
                    </div>
                  `;
                })
                .join("")}
            </div>

            <input
              type="hidden"
              class="bundle-native-item__variant-id"
              data-bundle-variant-id
              value="${variant?.id || ""}"
            >
          </div>
        </div>
      `;

      bindMountedVariantEvents(slotMount, product, slotIndex);
    }

    function renderSlots() {
  if (!slotsMount) return;

  const visibleSlots = getVisibleSlots();

  if (slotsLoading) {
    slotsMount.innerHTML = visibleSlots
      .map((slot) => {
        return `
          <div class="bundle-detail-slot bundle-detail-slot--loading">
            <div class="bundle-detail-slot__label">${slot.label}</div>
            <div class="bundle-detail-slot__loading">Loading products...</div>
          </div>
        `;
      })
      .join("");
    return;
  }

  slotsMount.innerHTML = visibleSlots
    .map((slot, slotIndex) => {
      const options = getSlotOptions(slot);
      const defaultProduct = getDefaultSelectedProduct(slot, options);

      let slotState = selectedStateBySlot[slotIndex];

      if (!slotState && defaultProduct) {
        slotState = {
          product: defaultProduct,
          variant: getDefaultVariant(defaultProduct)
        };
        selectedStateBySlot[slotIndex] = slotState;
      }

      const selectedProduct = slotState?.product || null;

      if (!selectedProduct) {
        return `
          <div class="bundle-detail-slot">
            <div class="bundle-detail-slot__label">${slot.label}</div>
            <div class="bundle-detail-slot__type">No products available for this design.</div>
          </div>
        `;
      }

      return `
        <div class="bundle-detail-slot" data-bundle-slot="${slotIndex}">
          <div class="bundle-detail-slot__label">${slot.label}</div>

          ${
            options.length > 1
              ? `
                <div class="bundle-detail-slot__pills">
                  ${options
                    .map(
                      (product) => `
                        <button
                          type="button"
                          class="bundle-detail-slot__pill ${String(product.id) === String(selectedProduct.id) ? "is-active" : ""}"
                          data-bundle-slot-pill
                          data-slot-index="${slotIndex}"
                          data-product-id="${product.id}"
                        >
                          ${product.type || product.title}
                        </button>
                      `
                    )
                    .join("")}
                </div>
              `
              : ""
          }

          <div
            class="bundle-detail-slot__mount"
            data-bundle-slot-mount
            data-slot-index="${slotIndex}"
          ></div>
        </div>
      `;
    })
    .join("");

  slotsMount.querySelectorAll("[data-bundle-slot-pill]").forEach((pill) => {
    pill.addEventListener("click", () => {
      const slotIndex = Number(pill.dataset.slotIndex);
      const slot = visibleSlots[slotIndex];
      const options = getSlotOptions(slot);

      const selectedProduct =
        options.find((product) => String(product.id) === String(pill.dataset.productId)) || null;

      if (!selectedProduct) return;

      selectedStateBySlot[slotIndex] = {
        product: selectedProduct,
        variant: getDefaultVariant(selectedProduct)
      };

      renderSlots();
      updatePrice();
    });
  });

  visibleSlots.forEach((slot, slotIndex) => {
    const slotState = selectedStateBySlot[slotIndex];
    const mount = slotsMount.querySelector(`[data-bundle-slot-mount][data-slot-index="${slotIndex}"]`);

    if (mount && slotState?.product) {
      mountProductTemplate(mount, slotState.product, slotIndex);
    }
  });

  updatePrice();
}

    async function applyDesignChange(nextDesignHandle, { closeModal = false, prioritizeRail = false } = {}) {
  activeDesignHandle = nextDesignHandle;
  activeDesignPage = 1;
  prioritizeSelectedDesignInRail = prioritizeRail;
  selectedStateBySlot = {};

  setDesignLoading(true);
  setSlotsLoading(true);

  try {
    activeDesignProducts = await fetchDesignProducts(activeDesignHandle);
    renderDesignRail();
    renderDesignGrid();

    if (closeModal) {
      modal?.setAttribute("hidden", "");
    }
  } catch (error) {
    console.error("Failed to load design products", error);
  } finally {
    setSlotsLoading(false);
    setDesignLoading(false);
    renderSlots();
    updatePrice();
  }
}

    function renderDesignGrid() {
      if (!designGrid) return;

      const paginatedGroups = getPaginatedDesignGroups();
      const filteredGroups = getFilteredDesignGroups({ prioritizeSelected: true });

      if (!filteredGroups.length) {
        designGrid.innerHTML = `<div class="bundle-detail__design-empty">No designs found.</div>`;
        if (designPagination) designPagination.innerHTML = "";
        return;
      }

      designGrid.innerHTML = paginatedGroups
        .map((group) => {
          const isActive = group.handle === activeDesignHandle;

          return `
            <button
              type="button"
              class="bundle-detail__design-card ${isActive ? "is-active" : ""}"
              data-bundle-design-card
              data-design-handle="${group.handle}"
            >
              <span class="bundle-detail__design-card-image-wrap">
                ${group.image ? `<img src="${group.image}" alt="${group.name}" class="bundle-detail__design-card-image">` : ""}
              </span>
              <span class="bundle-detail__design-card-name">${group.name}</span>
            </button>
          `;
        })
        .join("");

      if (designPagination) {
        const totalPages = getModalPageCount();

        designPagination.innerHTML = Array.from({ length: totalPages }, (_, index) => {
          const page = index + 1;
          return `
            <button
              type="button"
              class="bundle-detail__design-page-button ${page === activeDesignPage ? "is-active" : ""}"
              data-bundle-design-page
              data-page="${page}"
            >
              ${page}
            </button>
          `;
        }).join("");

        designPagination.querySelectorAll("[data-bundle-design-page]").forEach((button) => {
          button.addEventListener("click", () => {
            activeDesignPage = Number(button.dataset.page);
            renderDesignGrid();
          });
        });
      }

      designGrid.querySelectorAll("[data-bundle-design-card]").forEach((button) => {
        button.addEventListener("click", async () => {
          await applyDesignChange(button.dataset.designHandle, {
            closeModal: true,
            prioritizeRail: true
          });
        });
      });
    }

    function renderDesignRail() {
      if (!designRail) return;

      const sortedGroups = getSortedDesignGroups({
        prioritizeSelected: prioritizeSelectedDesignInRail
      }).slice(0, railDesignLimit);

      designRail.innerHTML = sortedGroups
        .map((group) => {
          const isActive = group.handle === activeDesignHandle;

          return `
            <button
              type="button"
              class="bundle-detail__design-rail-card ${isActive ? "is-active" : ""}"
              data-bundle-design-rail-card
              data-design-handle="${group.handle}"
            >
              <span class="bundle-detail__design-rail-card-image-wrap">
                ${group.image ? `<img src="${group.image}" alt="${group.name}" class="bundle-detail__design-rail-card-image">` : ""}
              </span>
              <span class="bundle-detail__design-rail-card-name">${group.name}</span>
            </button>
          `;
        })
        .join("");

      designRail.querySelectorAll("[data-bundle-design-rail-card]").forEach((button) => {
  button.addEventListener("click", async (event) => {
    if (designRail.classList.contains("is-dragging")) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    await applyDesignChange(button.dataset.designHandle, {
      closeModal: false,
      prioritizeRail: false
    });
  });
});
    }

    function generateBundleId() {
      return `bd_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    }

    function buildBundleCartItems() {

      const visibleSlots = getVisibleSlots();

  const selectedItems = Object.values(selectedStateBySlot).filter(
    (item) => item?.product && item?.variant
  );

  const bundleId = generateBundleId();

  const bundleName = recipe.name || "Bundle";
  const discountPercent = String(recipe.discount || 0);

  const bundleHandle = String(
    recipe.handle ||
    recipe.bundleHandle ||
    slugify(bundleName) ||
    "bundle"
  ).trim();

  const bundleDiscountKey = `${bundleHandle}-${discountPercent}`.toLowerCase();

  return selectedItems.map((item, index) => {
  const variantPrice = Number(item.variant?.price || 0);
  const compareAtPrice = Number(
    item.variant?.compare_at_price ||
    item.variant?.compareAtPrice ||
    item.variant?.compare_at_price_amount ||
    0
  );

  const bundleBasePrice = getBundleBasePrice(item.variant);
  const bundleDiscountedPrice = calculateDiscountedTotal(bundleBasePrice, Number(discountPercent || 0));
  const priceSource = compareAtPrice > variantPrice ? "compare_at_price" : "price";

  return {
    id: item.variant.id,
    quantity: 1,
    properties: {
      _bundle_id: bundleId,
      _bundle_name: bundleName,
      _bundle_handle: bundleHandle,
      _bundle_size: String(selectedItems.length),
      _bundle_discount_percent: discountPercent,
      _bundle_discount_key: bundleDiscountKey,
      _bundle_slot_index: String(index + 1),
      _bundle_slot_title: visibleSlots?.[index]?.label || `Item ${index + 1}`,
      _bundle_design_name: getActiveDesignMeta()?.name || "",
      _bundle_product_type: item.product?.type || "",
      _bundle_variant_title: String(item.variant?.title || "").replaceAll(" / ", " • "),
      _bundle_base_price: String(bundleBasePrice),
      _bundle_discounted_price: String(bundleDiscountedPrice),
      _bundle_actual_variant_price: String(variantPrice),
      _bundle_price_source: priceSource,
      _bundle_child: "true"
    }
  };
});
}

    async function refreshDrawerAfterBundleAdd() {
      const response = await fetch(`/?sections=cart-drawer,cart-icon-bubble`);
      const sections = await response.json();

      const drawerContainer = document.getElementById("CartDrawer");
      const bubbleContainer = document.getElementById("cart-icon-bubble");

      if (drawerContainer && sections["cart-drawer"]) {
        const parsedDrawer = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
        const newDrawer = parsedDrawer.querySelector("#CartDrawer");
        if (newDrawer) {
          drawerContainer.innerHTML = newDrawer.innerHTML;
        }
      }

      if (bubbleContainer && sections["cart-icon-bubble"]) {
        const parsedBubble = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
        const newBubble = parsedBubble.querySelector(".shopify-section");
        if (newBubble) {
          bubbleContainer.innerHTML = newBubble.innerHTML;
        }
      }

      window.updateBundleAwareCartBubble?.();

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        cartDrawer.classList.remove("is-empty");

        if (typeof window.bindBundleControls === "function") {
          window.bindBundleControls(cartDrawer);
        }

        if (typeof cartDrawer.open === "function") {
          cartDrawer.open();
        }
      }
    }

    async function addSelectedBundleToCart() {
      const items = buildBundleCartItems();
      if (!items.length) return;

      setAddButtonLoading(true);

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({ items })
        });

        const responseJson = await response.json();

        if (!response.ok || responseJson.status) {
          throw new Error(responseJson.description || "Failed to add bundle to cart");
        }

        await refreshDrawerAfterBundleAdd();
      } catch (error) {
        console.error(error);
        alert("There was a problem adding the bundle to cart.");
      } finally {
        setAddButtonLoading(false);
      }
    }

    function getMainTrack() {
      return root.querySelector("[data-bundle-main-track]");
    }

    function getMainSlides() {
      return Array.from(root.querySelectorAll("[data-bundle-main-slide]"));
    }

    function getThumbButtons() {
      return Array.from(root.querySelectorAll("[data-bundle-thumb]"));
    }

    function updateActiveThumb(index) {
      const buttons = getThumbButtons();

      buttons.forEach((button, buttonIndex) => {
        const item = button.closest("[data-bundle-thumb-item]");
        const isActive = buttonIndex === index;

        button.setAttribute("aria-current", isActive ? "true" : "false");
        item?.classList.toggle("is-active", isActive);
      });

      const activeButton = buttons[index];
      activeButton?.closest("[data-bundle-thumb-item]")?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest"
      });
    }

    function updateActiveSlide(index, animate = true) {
      const track = getMainTrack();
      const slides = getMainSlides();
      if (!track || !slides.length) return;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle("is-active", slideIndex === index);
      });

      if (!animate) {
        track.style.transition = "none";
      } else {
        track.style.transition = "";
      }

      track.style.transform = `translateX(-${index * 100}%)`;

      if (!animate) {
        requestAnimationFrame(() => {
          track.style.transition = "";
        });
      }
    }

    function goToImage(index, animate = true) {
      const slides = getMainSlides();
      if (!slides.length) return;

      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      activeImageIndex = index;
      updateActiveSlide(index, animate);
      updateActiveThumb(index);
    }

    function initBundleGalleryDrag(mainMedia) {
      const track = getMainTrack();
      const slides = getMainSlides();
      if (!track || !slides.length || !mainMedia) return;

      let isPointerDown = false;
      let startX = 0;
      let deltaX = 0;

      const endDrag = () => {
        if (!isPointerDown) return;

        isPointerDown = false;
        mainMedia.classList.remove("is-dragging");

        if (deltaX < -50) {
          goToImage(activeImageIndex + 1);
        } else if (deltaX > 50) {
          goToImage(activeImageIndex - 1);
        } else {
          goToImage(activeImageIndex);
        }

        deltaX = 0;
      };

      mainMedia.addEventListener("pointerdown", (event) => {
        isPointerDown = true;
        startX = event.clientX;
        deltaX = 0;
        track.style.transition = "none";
        mainMedia.classList.add("is-dragging");
      });

      window.addEventListener("pointermove", (event) => {
        if (!isPointerDown) return;

        deltaX = event.clientX - startX;
        const offsetPercent = (deltaX / mainMedia.offsetWidth) * 100;
        track.style.transform = `translateX(calc(-${activeImageIndex * 100}% + ${offsetPercent}%))`;
      });

      window.addEventListener("pointerup", endDrag);
      window.addEventListener("pointercancel", endDrag);

      mainMedia.addEventListener("dragstart", (event) => {
        event.preventDefault();
      });
    }

    function initBundleGallery() {
      const slides = getMainSlides();
      const buttons = getThumbButtons();
      const mainMedia = root.querySelector("[data-bundle-main-media]");
      if (!slides.length || !mainMedia) return;

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const index = Number(button.dataset.imageIndex || 0);
          goToImage(index);
        });
      });

      root.querySelector("[data-bundle-main-prev]")?.addEventListener("click", () => {
        goToImage(activeImageIndex - 1);
      });

      root.querySelector("[data-bundle-main-next]")?.addEventListener("click", () => {
        goToImage(activeImageIndex + 1);
      });

      let touchStartX = 0;
      mainMedia.addEventListener("touchstart", (event) => {
        touchStartX = event.changedTouches[0].clientX;
      });

      mainMedia.addEventListener("touchend", (event) => {
        const touchEndX = event.changedTouches[0].clientX;
        const deltaX = touchEndX - touchStartX;

        if (Math.abs(deltaX) < 40) return;
        if (deltaX < 0) goToImage(activeImageIndex + 1);
        else goToImage(activeImageIndex - 1);
      });

      initBundleGalleryDrag(mainMedia);
      goToImage(0, false);
    }

    
    function enableDragScroll(element) {
  if (!element || element.dataset.dragScrollEnhanced === "true") return;
  element.dataset.dragScrollEnhanced = "true";

  /*
    Stop native browser image/button dragging.
    This prevents design images from being pulled away while dragging.
  */
  function blockNativeDrag() {
    element.querySelectorAll("a, button, img").forEach((el) => {
      el.setAttribute("draggable", "false");

      if (el.dataset.nativeDragBlocked === "true") return;
      el.dataset.nativeDragBlocked = "true";

      el.addEventListener("dragstart", (event) => {
        event.preventDefault();
      });
    });
  }

  blockNativeDrag();

  const observer = new MutationObserver(() => {
    blockNativeDrag();
  });

  observer.observe(element, {
    childList: true,
    subtree: true
  });

  let isPointerDown = false;
  let startX = 0;
  let startScrollLeft = 0;
  let hasDragged = false;
  let maxScroll = 0;

  const DRAG_THRESHOLD = 4;

  function getMaxScroll() {
    return Math.max(0, element.scrollWidth - element.clientWidth);
  }

  function getElasticScroll(rawScroll) {
    maxScroll = getMaxScroll();

    /*
      Slider-like elastic resistance at both ends.
      Browser scroll containers cannot truly scroll past their limits,
      so this gives resistance before snapping back to the valid edge.
    */
    if (rawScroll < 0) {
      return rawScroll * 0.22;
    }

    if (rawScroll > maxScroll) {
      return maxScroll + (rawScroll - maxScroll) * 0.22;
    }

    return rawScroll;
  }

  function settleElasticScroll() {
    maxScroll = getMaxScroll();

    if (element.scrollLeft < 0) {
      element.scrollTo({
        left: 0,
        behavior: "smooth"
      });
    } else if (element.scrollLeft > maxScroll) {
      element.scrollTo({
        left: maxScroll,
        behavior: "smooth"
      });
    }
  }

  function stopDrag() {
    if (!isPointerDown) return;

    isPointerDown = false;
    settleElasticScroll();

    setTimeout(() => {
      element.classList.remove("is-dragging");

      /*
        Keep hasDragged true briefly so the click fired after mouseup
        does not accidentally select a design.
      */
      setTimeout(() => {
        hasDragged = false;
      }, 120);
    }, 0);
  }

  element.addEventListener("mousedown", (event) => {
    if (event.button !== 0) return;

    isPointerDown = true;
    hasDragged = false;
    startX = event.pageX;
    startScrollLeft = element.scrollLeft;
    maxScroll = getMaxScroll();

    event.preventDefault();
  });

  /*
    Use document-level movement.
    This keeps dragging smooth even if the cursor leaves the design rail area.
  */
  document.addEventListener("mousemove", (event) => {
    if (!isPointerDown) return;

    event.preventDefault();

    const deltaX = event.pageX - startX;
    const targetScroll = startScrollLeft - deltaX;
    const elasticScroll = getElasticScroll(targetScroll);

    if (Math.abs(deltaX) > DRAG_THRESHOLD) {
      hasDragged = true;
      element.classList.add("is-dragging");
    }

    element.scrollLeft = elasticScroll;
  });

  document.addEventListener("mouseup", stopDrag);

  element.addEventListener(
    "click",
    (event) => {
      if (hasDragged) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
}



    openModalBtn?.addEventListener("click", () => {
      activeDesignPage = 1;
      setDesignLoading(true);
      modal?.removeAttribute("hidden");

      requestAnimationFrame(() => {
        designSearchQuery = "";
        if (designSearchInput) {
          designSearchInput.value = "";
        }

        renderDesignGrid();
        setDesignLoading(false);
      });
    });

    designSearchInput?.addEventListener("input", (event) => {
      const nextValue = event.target.value || "";

      clearTimeout(designSearchTimeout);
      setDesignLoading(true);

      designSearchTimeout = setTimeout(() => {
        designSearchQuery = nextValue;
        activeDesignPage = 1;
        renderDesignGrid();
        setDesignLoading(false);
      }, 120);
    });

    closeModalBtns.forEach((button) => {
      button.addEventListener("click", () => {
        modal?.setAttribute("hidden", "");
      });
    });

    modal?.addEventListener("click", (event) => {
      if (event.target === modal) {
        modal.setAttribute("hidden", "");
      }
    });

    addButton?.addEventListener("click", addSelectedBundleToCart);

    initBundleGallery();
    renderDesignRail();
    renderDesignGrid();

    activeDesignProducts = data.initialDesignProducts || [];
    renderSlots();
    enableDragScroll(designRail);
    updatePrice();
  });
});